import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import {
  Headline1,
  Headline4,
  Paragraph2,
  Paragraph3,
} from '@nexus/lib-react/dist/core/Typography';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

const Dac7ContentSuccessContainer = styled.div`
  background-color: ${({ theme }) => theme.colors['background-global-primary']};
  ${mq.desktop} {
    margin-top: 8px;
  }
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  ${mq.desktop} {
    margin-bottom: 48px;
    flex-direction: row;
  }
`;

const IconWrapper = styled.div`
  display: block;
  margin-right: 16px;
`;

const StepInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const H1 = styled(Headline1)`
  font-weight: 500;
  margin-top: 16px;
  margin-bottom: 32px;
  ${mq.desktop} {
    margin-bottom: 64px;
  }
`;

const H4 = styled(Headline4)`
  font-weight: 500;
  margin: 16px 0;
`;

const P2 = styled(Paragraph2)`
  font-weight: 500;
  margin: 4px 0;
`;

const P3 = styled(Paragraph3)`
  font-weight: 400;
  margin: 4px 0;
`;

const SButtonPrimaryDark = styled(ButtonPrimaryDark)`
  text-align: center;
  width: 100%;
`;

const CTAContainer = styled.div`
  width: 100%;
  ${mq.desktop} {
    width: auto;
  }
`;

export default {
  Dac7ContentSuccessContainer,
  StepsContainer,
  StepContainer,
  IconWrapper,
  StepInfoContainer,
  H1,
  H4,
  P2,
  P3,
  SButtonPrimaryDark,
  CTAContainer,
};
